export default class R {
    static ROOT_PATH = "/autyzm";
//    static ROOT_PATH = "";
    /**
     * code 01 (first 2 characters)
     */
    static stringId = class {
        static appname = 'appname';// 0x01000001
        static menutitle = 'menutitle';
        static autismmenu0 = 'autismmenu0';// 0x01000010

        static autismmenu1 = 'autismmenu1';// 0x01000010
        static autismmenu2 = 'autismmenu2';
        static autismmenu3 = 'autismmenu3';// 0x01000010
        static autismmenu4 = 'autismmenu4';
        static autismmenu5 = 'autismmenu5';// 0x01000010
        static autismmenu6 = 'autismmenu6';
        static autismmenu7 = 'autismmenu7';// 0x01000010
        static autismmenu8 = 'autismmenu8';
        static autismmenu9 = 'autismmenu9';// 0x01000010
        static autismmenu10 = 'autismmenu10';
        static autismmenu11 = 'autismmenu11';// 0x01000010
        static autismmenu12 = 'autismmenu12';
        static autismmenu13 = 'autismmenu13';// 0x01000010
        static autismmenu14 = 'autismmenu14';
        static autismmenu15 = 'autismmenu15';// 0x01000010
        static autismmenu16 = 'autismmenu16';
        static autismmenu17 = 'autismmenu17';// 0x01000010
        static autismmenu18 = 'autismmenu18';
        static autismmenu19 = 'autismmenu19';
        static autismmenu20 = 'autismmenu20';
        static a1 = 'a1';
        static a2 = 'a2';
        static a3 = 'a3';
        static a4 = 'a4';
        static a5 = 'a5';
        static a6 = 'a6';
        static a7 = 'a7';
        static a8 = 'a8';
        static a9 = 'a9';
        static a10 = 'a10';
        static a11 = 'a11';
        static a12 = 'a12';
        static a13 = 'a13';
        static a14 = 'a14';
        static a15 = 'a15';
        static a16 = 'a16';
        static a17 = 'a17';
        static a18 = 'a18';
        static a19 = 'a19';
        static a20 = 'a20';
        static a21 = 'a21';
        static a22 = 'a22';
        static a23 = 'a23';
        static a24 = 'a24';
        static a25 = 'a25';
        static a26 = 'a26';
        static a27 = 'a27';
        static a28 = 'a28';
        static a29 = 'a29';
        static form_result = 'form_result';
    }
}



// WEBPACK FOOTER //
// ./src/static/R.js